export const mobileApps = {
    event: "mobile_app_download_click",
    eventCategory: "mobile_app_download_page"
};
